import moment from 'moment-business-days';
import _ from 'underscore';
const localize = (momentObj) => {
    momentObj.locale('us', {
        holidays: [
            '12-25-2015',
            '01-01-2016',
            '05-30-2016',
            '07-04-2016',
            '09-05-2016',
            '11-24-2016',
            '12-26-2016'
        ],
        holidayFormat: 'MM-DD-YYYY'
    });
};
const contextualizeDate = (dateMoment) => {
    localize(dateMoment);
    return dateMoment.utc().toDate().toISOString();
};
const definePeriod = (name, start, end, days) => {
    return {
        name,
        start: start,
        end: end,
        days
    };
};
const getPeriod = (dateMoment, daysInPeriod) => {
    localize(dateMoment);
    var name = dateMoment.format('MMMM');
    var start = contextualizeDate(dateMoment.clone().startOf('month'));
    return definePeriod(name, start, contextualizeDate(dateMoment.clone()), daysInPeriod);
};
const getComparisonPeriod = (dateMoment, daysInPeriod) => {
    localize(dateMoment);
    let start = dateMoment.startOf('month');
    let businessDays = dateMoment.monthBusinessDays();
    let currentBusinessDay;
    let days = daysInPeriod;
    if (businessDays.length < daysInPeriod) {
        currentBusinessDay = _.last(businessDays);
        days = businessDays.length;
    }
    else {
        currentBusinessDay = businessDays[daysInPeriod - 1];
    }
    return definePeriod(dateMoment.format('MMMM'), contextualizeDate(start), contextualizeDate(currentBusinessDay.endOf('day')), days);
};
export function getFrequentShippersPeriod(date) {
    const dateMoment = moment(date);
    localize(dateMoment);
    return definePeriod(dateMoment.format('MMMM'), contextualizeDate(dateMoment.subtract(1, 'month')), date);
}
;
export function getGrowthReportPeriods(date) {
    const dateMoment = moment(date).endOf('day');
    const days = dateMoment.businessDaysIntoMonth();
    const period = getPeriod(dateMoment, days);
    const comparisonDateMoment = dateMoment.clone().subtract(1, 'month');
    const comparisonPeriod = getComparisonPeriod(comparisonDateMoment, days);
    return [period, comparisonPeriod];
}
;
export function getDailyReportPeriods(date) {
    const end = contextualizeDate(moment(date).endOf('day'));
    const today = definePeriod('Today', contextualizeDate(moment(date).startOf('day')), end);
    const WTD = definePeriod('WTD', contextualizeDate(moment(date).startOf('week')), end);
    const MTD = definePeriod('MTD', contextualizeDate(moment(date).startOf('month')), end);
    const YTD = definePeriod('YTD', contextualizeDate(moment(date).startOf('year')), end);
    return [today, WTD, MTD, YTD];
}
;
export function getDailyReportLookbackPeriods(date) {
    const dateMoment = moment(date);
    let days = 8;
    let lookbackDays = [
        definePeriod(dateMoment.format('MM-DD-YYYY'), contextualizeDate(dateMoment.clone().startOf('day')), contextualizeDate(dateMoment.clone().endOf('day')))
    ];
    while (days > 0) {
        let day = dateMoment.prevBusinessDay();
        let start = contextualizeDate(day.clone().startOf('day'));
        let end = contextualizeDate(day.clone().endOf('day'));
        lookbackDays.push(definePeriod(day.format('MM-DD-YYYY'), start, end));
        days--;
    }
    return lookbackDays;
}
;
